import $http from '@vue-util/http';

/**
 * @typedef {Object} HttpResponse
 * @property {any} data - The response data.
 */

/**
 * Performs a GET request to the specified URL.
 * If the URL is an array, it performs multiple GET requests and combines the results.
 * @template T
 * @param {string|string[]} url - The URL or an array of URLs to send the request to.
 * @param {Object} [data] - The query parameters for the GET request.
 * @returns {Promise<T>} - A promise that resolves to the response data.
 */
export function get(url, data) {
  console.log(`Calling GET: ${url}`); // eslint-disable-line

  if (Array.isArray(url)) {
    return Promise.all(url.map((u) => $http.get(u, data)
      .then(/** @param {HttpResponse} res */ (res) => res.data)))
      .then((res) => res.reduce((acc, cur) => Object.assign(acc, cur), {}));
  }

  return $http.get(url, data).then(/** @param {HttpResponse} res */ (res) => res.data);
}

/**
 * Performs a POST request to the specified URL.
 *
 * @template T
 * @param {string} url - The URL to send the POST request to.
 * @param {Object} data - The data to be sent in the request body.
 * @param {Object} [config] - Additional request configurations.
 * @returns {Promise<T>} - A promise that resolves to the response data.
 */
export function post(url, data, config) {
  console.log(`Calling POST: ${url}`); // eslint-disable-line
  return $http.post(url, data, config).then(/** @param {HttpResponse} res */ (res) => res.data);
}

/**
 * Performs a DELETE request to the specified URL.
 *
 * @template T
 * @param {string} url - The URL to send the DELETE request to.
 * @param {Object} [config] - Additional request configurations.
 * @returns {Promise<T>} - A promise that resolves to the response data.
 */
export function deleteApi(url, config) {
  console.log(`Calling DELETE: ${url}`); // eslint-disable-line
  return $http.delete(url, config).then(/** @param {HttpResponse} res */ (res) => res.data);
}
